let nuevoElemento = document.createElement("img");
nuevoElemento.src = "https://cdn.shopify.com/s/files/1/0456/7338/2052/files/close.png";
nuevoElemento.alt = "Close";
nuevoElemento.width = 30;
nuevoElemento.id = "closeModalBtn";

/*let nuevoElemento = document.createElement("span");
nuevoElemento.textContent = "X";
nuevoElemento.id = "closeModalBtn";*/
document.getElementById("AU1B6TzFlaXRiWDFme__forms_inline_iYQdQG").appendChild(nuevoElemento);

// Obtener elementos
let modal = document.getElementById("AU1B6TzFlaXRiWDFme__forms_inline_iYQdQG");
document.body.appendChild(modal);
let openModalBtn = document.getElementById("openModalBtn");
let closeModalBtn = document.getElementById("closeModalBtn");
console.log(modal);  

// Abrir el modal al hacer clic en el botón
openModalBtn.addEventListener("click", function() {
  event.preventDefault()
  modal.style.display = "flex";
  document.querySelector('body').classList.add('overflow-hidden');
});

// Cerrar el modal al hacer clic en la "X"
closeModalBtn.addEventListener("click", function() {
  modal.style.display = "none";
  document.querySelector('body').classList.remove('overflow-hidden');
});

// Cerrar modal si el usuario hace clic fuera de él
window.addEventListener("click", function(event) {
    if (event.target === modal) {
      modal.style.display = "none";
      document.querySelector('body').classList.remove('overflow-hidden');
    }
});